import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { alpha } from '@mui/system';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GeneralModal from './Modal';
const PREFIX = 'StepStopButton';

const classes = {
  stopButton: `${PREFIX}-stopButton`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.stopButton}`]: {
    color: theme.palette.error.main,
    marginRight: theme.spacing(1),
    borderColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.error.main, 0.1),
    },
  },
}));

const StepStopButton = ({ disabled, where, orderId }) => {
  const { t } = useTranslation('workOrdersTable');
  const isDisabled = disabled === 'true';
  const [currentModal, setCurrentModal] = useState('initialForm');
  const [modalState, setModalState] = useState(false);
  const handleModalState = () => {
    setModalState(!modalState);
    setCurrentModal('initialForm');
  };

  return (
    <Root>
      <Button
        className={classes.stopButton}
        variant="outlined"
        size="small"
        disabled={isDisabled}
        onClick={() => handleModalState()}
      >
        {t('card.hiddenContent.processStepButtons.stop')}
      </Button>
      <GeneralModal
        modalState={modalState}
        forms={[]}
        initFormName={currentModal}
        handleModalState={handleModalState}
      />
    </Root>
  );
};

export default StepStopButton;
